export const NO_GUIDELINE = "no_guideline";
